/**
 * Marketing typography CSS variable class hook for Vite SPA.
 * The font faces and CSS custom properties (--font-general-sans,
 * --font-space-grotesk, --font-open-sans, --font-inter) are defined
 * in src/pages/globals.css and loaded via index.html / @font-face.
 */
export const marketingFontVariables = "marketing-fonts";
